import { loginProps } from "../../interfaces";
import {
  HANDLE_LOGIN,
  HANDLE_FETCH_AMADEUS_TOKEN,
  HANDLE_LOGOUT,
  FETCH_USER_PERMISSIONS,
  HANDLE_SEND_OTP,
  HANDLE_SUBMIT_OTP,
  HANDLE_CHANGE_PASSWORD,
} from "./types";

export const login = (payload: loginProps) => {
  return {
    type: HANDLE_LOGIN,
    payload,
  };
};

export const logout = () => {
  localStorage.removeItem("deviceToken");
  for (let i = localStorage.length - 1; i >= 0; i--) {
    const key = localStorage.key(i);
    if (key?.startsWith("viewQueryReason_")) {
      localStorage.removeItem(key);
    }
  }
  return {
    type: HANDLE_LOGOUT,
  };
};

export const fetchAmadeusToken = () => {
  return {
    type: HANDLE_FETCH_AMADEUS_TOKEN,
  };
};

export const fetchUserPermissions = (payload?: any) => {
  return {
    type: FETCH_USER_PERMISSIONS,
    payload,
  };
};

export const sendOtp = (payload: any) => {
  return {
    type: HANDLE_SEND_OTP,
    payload,
  };
};

export const submitOtp = (payload: any) => {
  return {
    type: HANDLE_SUBMIT_OTP,
    payload,
  };
};

export const changePassword = (payload: any) => {
  return {
    type: HANDLE_CHANGE_PASSWORD,
    payload,
  };
};
